export const ADD_INFO_TITLE_NAME = "AddInfoTitle";
export const ADD_INFO_TITLE_HASH = "FRESHBOX_ADD_INFO_TITLE";
export const BOX_HASH_VIDEO = "VIDEO";
